export default [
  {
    id: 'bok-thye-yeow',
    name: 'Bok Thye Yeow',
    position: 'DevRel Program Manager',
    company: 'Google',
    country: 'Singapore',
    bio: `Bok Thye Yeow has more than a decade of experience developing full stack software solutions across various industries including telco, banking, digital and creative advertising, retail, etc. During his free time, he likes to experiment with new technology or fly his home-made drone. At Google, Bok leads developer programs focusing on professional and enterprise developers like Machine Learning Bootcamps across the region. Recently he and his team is working towards building a home for developers and startups across the region aka Developer Space @ Google Singapore. He strongly believes we are only starting to scratch the surface of what's possible with technology in this era and is looking forward to the "next big thing" to come!`,
    session: 'Keynote',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fbok-thye-yeow.jpg?alt=media&token=b1e3f334-42fc-4621-a6ac-94d34ebf368b'
  },
  // {
  //   id: 'mark-birch',
  //   name: ' Mark Birch',
  //   position: 'Regional Director for APAC',
  //   company: 'Stack Overflow',
  //   country: 'United States',
  //   bio:
  //     'Currently the Regional Director for APAC at Stack Overflow, a global Q&A community platform for developers to share knowledge and collaborate, Mark works with C-level executives to demonstrate how software developers are the key to unlocking innovation and provide advice on how to engage them. He is also the founder of the Enterprise Sales Forum, a community for B2B sales professionals and leaders to share ideas, network with peers, and learn innovations in the field of sales comprising over 20 global chapters and 25,000 members. Previously he worked at a diverse group of leading technology companies including Oracle, E.piphany and Siebel. Mark graduated with a Bachelor of Science in Electrical Engineering from Boston University.',
  //   session: 'Building Internal Developer Communities',
  //   imageURL:
  //     'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fmark-birch.jpg?alt=media&token=b6c071b4-6a16-4c17-a388-ba64043f22f7'
  // },
  {
    id: 'jason-demetillo',
    name: 'Jason Demetillo',
    position: 'Lead Designer',
    company: 'Grab',
    country: 'Singapore',
    bio: `With 10+ years of experience working in New York City to San Francisco and now Singapore, Jay Demetillo has almost seen it all in the design world.
Jay has worked with Twitter, Pinterest, Yahoo, and Grab. He's also worked on notable projects such as the Bay Lights, Gaspar Brasserie, and San Francisco's Park System SFPark. Jay is an adjunct professor at CCA in San Francisco and has taught/spoken in China for ACG. Educated as a print designer at first, Jay has pushed his career by evolving with the trends whether if it was motion design to UX design, he’s become the do-it-all designer and is ready talk about his journey.`,
    session: 'Designing for Cultures: Redesigning GrabFood',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjason-demetillo.jpg?alt=media&token=ff2e0243-908d-427e-8fe8-c7d188c97989'
  },
  {
    id: 'amit-walia',
    name: 'Amit Paul Walia',
    position: 'CEO and Founder',
    company: 'SEO Experte',
    country: 'Switzerland',
    bio: `Amit Walia, born 1985, certified online marketing manager and experienced web designer.
What drives him: 16 years of passion and fascination for the web.
His passion is bringing the latest solutions to his clients and search engine marketing. During his professional career in various web agencies, he optimized websites for numerous clients. These ranged from international companies with almost unlimited budgets to regional small businesses.
Instead of resting on his extensive know-how, he uses every opportunity to further expand his expertise. He was an Online Marketing instructor at the SAE Institute in Switzerland and also a guest speaker in tech talks in Berlin, Germany.`,
    session: 'Fearless SEO',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Famit-walia.jpg?alt=media&token=5a323cd1-8983-44e9-89b8-c7fc2054f958'
  },
  // {
  //   id: 'akshay-bahadur',
  //   name: 'Akshay Bahadur',
  //   position: 'Software Development Engineer',
  //   company: 'Symantec',
  //   country: 'India',
  //   bio: `Akshay Bahadur’s interest towards Computer Science sparked when he was working on a women's safety application aimed towards the women welfare in India and since then he has been incessantly working on improving his skills. He has made successful prototypes such as an autonomous car, alphabet recognition, cancer classification, gesture recognition with the use of learning models. These prototypes showcase the power of deep learning and how it can help your organization implement learning models to solve business cases. His ambition is to make valuable contribution towards ML community and leave a message of perseverance and tenacity. Currently,  working as a Software Engineer at Symantec, India. He’s one of the 8 Google Developer Experts (Machine Learning) from India along with being one of the 150 members worldwide for Intel Software Innovator program and is also deeply influenced by literature especially Shakespeare's work.`,
  //   session: 'Resource utilization as a metric for Machine Learning',
  //   imageURL:
  //     'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fakshay-bahadur.jpg?alt=media&token=2ef868f2-1270-4286-9d5b-19c624541d6a'
  // },
  {
    id: 'vin-lim',
    name: 'Vin Lim',
    position: 'Director',
    company: 'Green Room',
    country: 'Malaysia',
    bio: `Vin is the Co-Founder and CEO of Green Room, a leading mobile and web application development company, with a portfolio of major international and local brands. Together with his team, he specialises in cross-platform application development, with technologies like TypeScript, Angular and various modern web technologies. His journey in the tech and startup scene has sparked his enthusiasm in building tech community, leading to the founding of Startup Penang, GDG George Town and Angular Malaysia. To contribute to the ecosystem further, he has been speaking in various local and international tech conferences, promoting web technologies. When he is not working, you will find him tinkering and building stuff, from applications to hardwares.`,
    session: 'The Immersive Web: Bringing AR to the Open Web with WebXR',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fvin-lim.jpg?alt=media&token=95d7e26c-e916-4f0a-9c4a-0f8ddb804e46'
  },

  {
    id: 'henry-lim',
    name: 'Henry Lim',
    position: 'Web Developer',
    company: 'Google Developer Expert',
    country: 'Thailand',
    bio: `Henry is a Malaysian Google Developer Expert in Web Technologies. He is currently working as a front-end web developer in Thailand, Bangkok.

He loves to learn, experiment and share all the cool stuffs like Progressive Web Apps, Project Fugu (Web Capabilities), Preact, Firebase, and more.
    
Furthermore, he is the creator of Remote for Slides, a Chrome Extension + Progressive Web Apps that turns any device into a remote control for Google Slides.`,
    session: 'Building a Better Website with Chrome DevTools',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fhenry-lim.jpg?alt=media&token=6055ae3b-d0d4-428a-9701-43526a032a29'
  },

  {
    id: 'cho-eun',
    name: 'Cho Eun',
    position: 'Technical Program Manager',
    company: 'NAVER Corp',
    country: 'South Korea',
    bio: `Technical Program Manager at NAVER Corp, WebTech GDE, loves Flutter, photography, definitely cute things. Can Speak in Korean and Japanese.`,
    session: 'New Q&A app development with Flutter',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fcho-eun.jpg?alt=media&token=05c57b65-d9df-4c66-bf5f-02a772832efd'
  },
  {
    id: 'jason-zaman',
    name: 'Jason Zaman',
    position: 'Senior Staff Engineer',
    company: 'Light Labs',
    country: 'Singapore',
    bio: `Jason is the community lead for TensorFlow SIG-Build and is an ML-GDE. He works as a Machine Learning engineer at Light Labs doing computational photography in mobile cameras. Along with speaking regularly on different conferences, he is also active in Open Source development as a Gentoo Linux developer and maintainer of the SELinux Project.`,
    session: 'On-device ML with TensorFlow 2.0 and TFLite',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjason-zaman.jpg?alt=media&token=fc17581d-a9be-4dab-b579-86be5afdfcd3'
  },
  {
    id: 'jeongkyu-shin',
    name: 'Jeongkyu Shin',
    position: 'CEO / Researcher',
    company: 'Lablup Inc.',
    country: 'South Korea',
    bio:
      'Jeongkyu Shin is the Founder of Laplup Inc., an AI company in South Korea, membered with nine Ph.D cofounders and industry/acdemia-leading trailblazers. He is also a Google Developer Expert for Machine Learning and Sprint Master and an Adj. Professor at Hanyang University. A huge advocate of open source projects and has his interests in Opinion formation Dynamics on Complex Systems and studying or modeling neuroscience and social systems ',
    session: 'Boosting machine learning workflow with TensorFlow 2.0',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjeongkyu-shin.jpg?alt=media&token=12f7c76a-48bb-4461-b04a-5e2a9022be83'
  },
  {
    id: 'alex-solis',
    name: 'Alex Solis',
    position: 'Software Engineer',
    company: 'Cast & Crew',
    country: 'United States',
    bio: `Alex is currently working as a Software Engineer for Cast & Crew on projects using Typescript, Angular, and Electron, while contributing to their product design. 

    In the past, he has worked as a business analyst as well as a product lead, and has also employed UX Design and Agile Methodologies. His exposure to different roles has helped him methodically identify the needs of end users and improve the capabilities of development teams.
    
    Years of experience have helped him hone skills to examine business services through multiple lenses, aiming to provide timely, value-adding digital products for end users.
    
    He is a big geek for superheroes, anime, dancing, and cooking and uses these other forms of disciplines to innovate the efficient delivery of digital products.`,
    session: 'Building Digital Products for Transforming Industries',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Falex-solis.jpg?alt=media&token=2997c852-1a42-40a2-804c-1b0ac23aee20'
  },
  {
    id: 'gina-romero',
    name: 'Gina Romero',
    position: 'CEO & Co-Founder',
    company: 'Connected Women',
    country: 'Philippines',
    bio: 'Tech-smart, business-savvy, down to earth, inspired connector of people & ideas.',
    session: 'Inclusive Innovation',
    imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FGina_Romero.jpg?alt=media&token=19588e75-6e6b-4dc4-8f9f-793a475e619b'  },
  {
    id: 'audrey-pe',
    name: 'Audrey Pe',
    position: 'Founder and Executive Director',
    company: 'WiTech (Women in Technology)',
    country: 'Philippines',
    bio: 'Audrey is a 2019 Global Teen Leader who has an enormous love for STEM which fueled her up to start WiTech (Women in Technology)--a community organization that educates, inspires and empowers youth to break gender barriers and use technology to make positive differences in our society.',
    session:
      'Closing the Gender and Tech Accessibility Gaps that Exist in the Philippines',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FAudrey%20Pe.jpg?alt=media&token=abc81c71-a7ec-45fc-b9e4-6ef5036fb37d'
  },

  {
    id: 'joshua-deguzman',
    name: ' Joshua De Guzman',
    position: 'Mobile Software Engineer',
    company: 'Freelancer.com',
    country: 'Philippines',
    bio:
      "Joshua de Guzman works at Freelancer.com as a Mobile Engineer and he has been shipping native code to more than one million users in Android. Now, together with his team, are exploring the possibilities of integrating Flutter in their projects. He started a small community, Flutter Philippines (www.flutter.ph), together with the people passionate about learning Flutter to help share and grow the adaption of the technology here in the country. On his free time, you'll find him watching ABC's Shark Tank and some action movies on Netflix.",
    session: 'Integrate Flutter Views In Your Existing Native Mobile Codebase',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjoshua-de-guzman.jpg?alt=media&token=8dc45927-0f05-4edd-8646-41ab34cff25a'
  },
  {
    id: 'jean-alfonsodecea',
    name: 'Jean Alfonso-Decena',
    position: 'Senior AI Trainer and Designer',
    company: 'Starbutter AI',
    country: 'Philippines',
    bio: 'Jean Alfonso-Decena--a pioneer in Conversational AI Design and Training disrupting FinTech, Digital Marketing & Acquisition and Voice SEO. She helps bake bots for the Google-award winning Starbutter AI based in Skydeck, Berkeley in California. She’s a speaker, mentor and consultant on AI, Startups, Agile Methodology, Process Improvement, Talent Development and CS.',
    session: 'AI Workforce - Jobs of the Future in the Present',
    imageURL:
      'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjean-alfonso-decena.jpg?alt=media&token=59e231c3-803a-43b2-b39b-68700fc3c201'
  },
{
  id: 'marikit-valmadrid',
  name: 'Marikit Valmadrid',
  position: 'Community Manager',
  company: 'Philippine Web Designers Organization',
  country: 'Philippines',
  bio: 'Kit is a Google Cloud G Suite Certified, Community Manager of the Philippine Web Designers Organization, and a core member of WordPress User Group Philippines.',
  session: 'Productivity tools for the Not-So-Dummy',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fmarikit-valmadrid.jpg?alt=media&token=3710ce6b-a88e-4cbd-89ec-f8f266981de0'
   
},
{
  id: 'anthony-amanse',
  name: 'Anthony Amanse',
  position: 'Software Engineer',
  company: 'IBM',
  country: 'Philippines',
  bio: 'Anthony is a Software Developer focused on Cloud and Container Technology. Most of the time, he is working on applications deployed in Kubernetes. He is interested in applications in a Microservices Architecture. His favorite language is Javascript and likes to dabble in mobile development. In his free time, he enjoys playing basketball and rock climbing.',
  session: 'Cloud Native Development Patterns with Containers and Serverless',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fanthony-amase.jpg?alt=media&token=c31ddd5c-aa5d-4ef2-86fa-8e7476cfb269'
},
{
  id: 'anelle-denise-silerio',
  name: 'Anelle Denise Silerio',
  position: 'Founder and Creative Director',
  company: 'Illustrados Creatives and Technology',
  country: 'Philippines',
  bio: 'A creative entrepreneur that heads several web projects for start-ups and existing businesses. She studied Information Technology and Architecture and is always inspired by structural design and technology. Her love for art and composition lead her to pursue Design in Technology. As of now, She leads a team of web developers, web designers, social media managers, and content creators to develop innovative platforms and help start-up businesses build their brand.',
  session: 'The Impact of Good UX in our Lifestyle',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fanelle-denise-silerio.jpg?alt=media&token=c79804ae-4f75-4d83-87c9-551ab4e75e02'
 
},
{
  id: 'juan-carlos',
  name: 'Juan Carlos Roldán',
  position: 'Researcher',
  company: 'University of Seville',
  country: 'Spain',
  bio: 'He is a researcher at the University of Seville. Previously, he worked at the research facilities of the USC Information Sciences Institute in Marina del Rey, California. His research interests are: information extraction, social media analysis, and data science in general.',
  session: 'Turning web data into knowledge',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjuan-carlos-roldan.jpg?alt=media&token=61b71ab1-212b-4100-b158-68524d3a0360'
},
{
  id: 'lesley-zerna',
  name: 'Lesly Zerna',
  position: 'Cofounder & Educator',
  company: 'Mentor Her',
  country: 'Bolivia',
  bio: 'Lesly is from Bolivia. She loves traveling and meeting new people and learning from new cultures. She loves learning and teaching about technology. Lesly studied Telecom Engineering in Bolivia and completed a master in Computer Science in Belgium. Currently, she is a profesor at local university in Bolivia, but also a tech educator creating and developing content to teach about Machine Learning. She has been a TEDx speaker in 2018 in Bolivia, talking about education and start ups. She is also an activist for inclusion of more women in tech, cybersecurity and entrepreneurship culture. Cofounder of MentorHER the support for more girls into techs. Google Developer Expert in Machine Learning',
  session: ' AI ecosystems in Latin America to the Philippines',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Flesly-zerna.jpg?alt=media&token=de867f39-1bde-454b-860f-fe8f5bac5c15'
},
{
  id: 'gina-romero',
  name: 'Gina Romero',
  position: 'CEO & Co-Founder',
  company: 'Connected Women',
  country: 'Philippines',
  bio: 'Tech-smart, business-savvy, down to earth, inspired connector of people & ideas.',
  session: 'Inclusive Innovation',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FGina_Romero.jpg?alt=media&token=2a55ca39-c297-490a-80a0-2657837038e3'
},
{
  id: 'jielynn-diroy',
  name: 'Jielynn Diroy',
  position: 'Women Techmaker Ambassador / #IamRemarkable Ambassador',
  company: 'Google Developer Group Philippines',
  country: 'Philippines',
  bio: 'Jielynn is a Java developer in Malaysia and a project manager in Philippines. She wants to spend her free time managing different teams with a goal that each one would be satisfied and successful -- through Sims 4. Jielynn has been fond of Google Technologies and products since she was in college. This became the fuel of her passion into gaining and sharing knowledge to and from the community. She is the Women Techmaker Ambassador, #IamRemarkable Ambassador and one of the community heads of GDG Philippines. She is also starting a diversity-focused community --  Women Techmakers Manila.',
  session: '#IamRemarkable Workshop',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FFB_IMG_1560843866007%20-%20Jielynn%20Diroy.jpg?alt=media&token=c9d98fe1-92f0-4854-8fda-16a351bad6a4'
},
{
  id: 'sheryl-kamantigue',
  name: 'Sheryl D. Kamantigue',
  position: 'Academic Teaching Faculty',
  company: 'De La Salle University - Dasmariñas',
  country: 'Philippines',
  bio: 'Sheryl has been in the Academe for almost 20 years and is teaching BSCS and BSIT students.',
  session: 'Panel Discussion: Modern Diversity',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FSheryl_Kamantigue.jpg?alt=media&token=a175ac8c-4cac-4cf5-a2dd-29930c739fc0'
},
{
  id: 'isabel-sieh',
  name: 'Isabel Sieh',
  position: 'Founder and Executive Director',
  company: 'Girls Will Code',
  country: 'Philippines',
  bio: 'Isabel is the founder and Executive Director of Girls Will Code, a community organization encouraging and helping girls to take part in coding and STEM, and the Co-Founder of The Coding School.  She is 16 years old and enjoys learning about all things tech, playing tennis, and spending time with family and friends. She is a Youth Champion for SDG 5: Gender Equality and a Youth Innovators Program Awardee. ',
  session: 'Panel Discussion: Modern Diversity',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FIsabel%20Sieh.JPG?alt=media&token=3c9ddc71-23b4-4b82-a785-c78230620262'
},
{
  id: 'christian-clemente',
  name: 'Christian Justine G. Clemente',
  position: 'AI Research Engineer',
  company: 'Senti AI',
  country: 'Philippines',
  bio: '',
  session: 'Natural Language Processing with Deep Learning using Tensorflow 2.0 ',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FJustine%20Clemente.jpg?alt=media&token=80e97f50-d52b-421f-b184-e5345a80e6c4'
},
{
  id: 'joie-cruz',
  name: 'Joie Cruz',
  position: 'Founder and CEO',
  company: 'Limitless Lab',
  country: 'Philippines',
  bio: 'Joie is the founder and CEO of Limitless Lab – a strategic design and innovation company helping businesses, non-profits, and governments innovate and challenge the status quo using human-centered design. Joie is passionate about enabling creativity, collaboration, and meaningful connections. Her previous work at the Department of ICT inspired her to advocate for creative leadership and innovation in government. She also organizes and facilitates startup community events including Startup Weekends. Outside of work, Joie spends her time traveling, volunteering, and studying more about spirituality, meditation, and personal growth.',
  session: 'Designing for Public Sector Innovation',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fjoie_cruz.png?alt=media&token=087154f2-d613-485f-8e79-8f2a2c3731c2'
},
{
  id: 'sarah-elago',
  name: 'Sarah Jane Ibañez Elago',
  position: 'Representative, Kabataan Partylist',
  company: '',
  country: 'Philippines',
  bio: 'A student and youth leader before she became a public servant, this lady legislator is a former Vice Chairperson of the UP Diliman College of Home Economics and a Councilor of the UP Diliman University Student Council while serving the University as a resident performer, musician and dancer of the UP Repertory Company and the UP Kontemporaryong Gamelan Pilipino.  After graduating with honors, she figured in the National Union of Students of the Philippines, as its National President, where she led the Rise for Education Alliance, Youth for Accountability and Truth Now or Youth Act Now and Save Our Schools Network.  At present, she serves in the House of Representatives as the Congresswoman of Kabataan Partylist. Principally authoring laws on free public higher education and free public internet access, she has become one of the most prolific two-term legislators thus far. She is also a member of the ASEAN Parliamentarian for Human Rights and the Global Equality Caucus.',
  session: 'Panel Discussion: Modern Diversity',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fsarah%20elago.jpg?alt=media&token=dc0be9d0-155b-49c3-80e0-9c551c8a4dd0'
},
{
  id: 'carissa-coless',
  name: 'Carissa Coles',
  position: 'Digital Head / Operations Manager',
  company: 'EmergeLocal Inc.',
  country: 'Philippines',
  bio: 'Carissa is the Digital Head for EmergeLocal where she in charge of overall digital marketing campaigns of their clients. She worked on successful social media campaigns for OMNI Aviation (Aviation), ISCAHM (Culinary School), Clark International Airport (Aviation), and more. She is a Certified Community Manager by Digital Marketer, Hootsuite Professional, Social Media Manager School alumni by Andrea Vahl, and Google Ads and Analytics certified. Delivered trainings to more than 1,000 audiences about Digital Marketing, Google Ads, Google tools, and Entrepreneurship.',
  session: 'Panel Discussion: Modern Diversity',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2Fcarissacoles%20-%20Carissa%20Coles.png?alt=media&token=85587fc6-c34b-4eec-b8cd-3423d017fd99'
},
{
  id: 'joselito-samson',
  name: 'Jay Samson',
  position: 'Associate Director',
  company: 'Accenture Inc',
  country: 'Philippines',
  bio: 'Jay as an Associate Director in Accenture Inc, lead the design thinking capability and business agility capability in the centre. He is the resident of the Liquid Studio in manila, that promotes a culture of innovation, not just in Accenture but with the clients that visit the studio. He is the first global certified Design Thinking expert in Accenture APAC, and now share such expertise to the clients of Accenture and the local academe partners.',
  session: 'New ways of working in the Digital Revolution: Grow and Diversify your skills',
  imageURL: 'https://firebasestorage.googleapis.com/v0/b/devfestph.appspot.com/o/Speaker%20Photos%2FJayProfile%20-%20Jay%20Samson.jpg?alt=media&token=55a83921-ff69-4540-b331-8d2376468a1d'
}
];

